import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Header,
  Icon as SemanticIcon,
  Message,
  Button,
  Form
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";

import { addSubmitter } from "../../actions/unauthenticated/organization";

class AddSubmitterForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      submitting: false,
      error: false,
      success: false
    };
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.email.indexOf("@") > 0;
  }

  handleChange = event => {
    this.setState({
      email: event.target.value,
      error: false
    });
  };

  handleSubmit = () => {
    this.setState({
      submitting: true
    });
    this.props
      .addSubmitter(this.state.email)
      .then(() => {
        this.setState({
          success: true
        });
      })
      .catch(error => {
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "There was an error.";
        this.setState({
          error: errorMessage
        });
      })
      .finally(() => {
        this.setState({
          submitting: false
        });
      });
  };

  render() {
    return (
      <Form
        loading={this.state.submitting}
        style={{ padding: "0 10px" }}
        error={!!this.state.error}
        success={this.state.success}
      >
        <Form.Group style={{ marginBottom: "1em" }}>
          <Form.Input
            width={16}
            icon="user"
            iconPosition="left"
            label="E-mail"
            type="email"
            required
            placeholder="jason@example.com"
            disabled={this.state.success}
            value={this.state.email}
            onChange={this.handleChange}
            error={!!this.state.error}
            id="email"
          />
        </Form.Group>
        {this.state.success && (
          <Message success>
            We've successfully added you. Check your e-mail for confirmation!
          </Message>
        )}
        {!!this.state.error && <Message error>{this.state.error}</Message>}
        <div style={{ textAlign: "right" }}>
          <Button
            primary
            disabled={
              !this.validateForm() ||
              this.state.submitting ||
              this.state.success
            }
            onClick={this.handleSubmit}
          >
            Add
          </Button>
        </div>
      </Form>
    );
  }
}

const SubmitterSignupView = props => {
  return (
    <div>
      <Header as="h2" dividing>
        <SemanticIcon name="user" />
        <Header.Content>
          Add yourself to {props.organization.name}
          <Header.Subheader>
            Adding your e-mail allows you to submit reimbursements.
          </Header.Subheader>
        </Header.Content>
      </Header>
      <AddSubmitterForm addSubmitter={props.addSubmitter} />
    </div>
  );
};

const mapStateToProps = state => ({
  organization: state.unauthenticated.organization,
  addSubmitter: addSubmitter(
    state.unauthenticated.organization.uuid,
    state.unauthenticated.organization.modify_key
  )
});

export default withRouter(connect(mapStateToProps)(SubmitterSignupView));



// WEBPACK FOOTER //
// ./frontend/src/views/unauthenticated/SubmitterSignupView.js